import React from 'react'
import { colors } from '../../constants'
import classNames from 'classnames'
import { makeStyles } from '@material-ui/core'
import { Tooltip, Typography } from '../index'

const useStyles = makeStyles({
  statusText: {
    fontSize: 12,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  activeStatus: {
    color: colors.SUCCESS,
  },
  inactiveStatus: {
    color: colors.BASIC.COLOR[60],
  },
  pendingStatus: {
    color: colors.PRIMARY.COLOR[40],
  },
  rejectedStatus: {
    color: colors.ERROR,
  },
  stoppedStatus: {
    color: colors.BASIC.COLOR[80],
  },
  statusTooltip: {
    fontSize: 13,
    fontWeight: 'normal',
    color: colors.WHITE,
    backgroundColor: colors.BASIC.COLOR['80'],
  },
})

const CASE_STATUS_CONFIG = {
  active: {
    label: 'Active',
    color: 'activeStatus',
    tooltip: 'Case is active and can be worked on',
  },
  inactive: {
    label: 'Inactive',
    color: 'inactiveStatus',
    tooltip: 'Case is inactive and cannot be worked on',
  },
  pending: {
    label: 'Pending',
    color: 'pendingStatus',
    tooltip: 'Case is pending approval or processing',
  },
  rejected: {
    label: 'Rejected',
    color: 'rejectedStatus',
    tooltip: 'Case has been rejected',
  },
  stopped: {
    label: 'Stopped',
    color: 'stoppedStatus',
    tooltip: 'Case has been stopped',
  },
}

const CaseStatus = ({ status, title, showTooltip = true }) => {
  const classes = useStyles()
  const statusConfig = CASE_STATUS_CONFIG[status] || CASE_STATUS_CONFIG.inactive

  const statusElement = (
    <Typography
      variant="body2"
      classes={{
        root: classNames(classes.statusText, classes[statusConfig.color]),
      }}
    >
      {statusConfig.label}
    </Typography>
  )

  if (showTooltip) {
    return (
      <Tooltip title={title || statusConfig.tooltip} tooltipClass={classes.statusTooltip}>
        {statusElement}
      </Tooltip>
    )
  }

  return statusElement
}

export default CaseStatus
